module.exports = __webpack_public_path__ + "img/oval.2572cf72.svg";